import type { MouseEvent } from 'react';

export const MIDDLE_MOUSE_CLICK_BUTTON = 1;

export const isMiddleMouseClick = (event: MouseEvent) => event.button === MIDDLE_MOUSE_CLICK_BUTTON;
